interface MovieRatingProps {
  rating: number;
}

export default function MovieRating({ rating }: MovieRatingProps) {
  const fullStars = Math.round(rating / 2);
  return (
    <div className="rounded-lg bg-secondary-100 p-5">
      <div className="flex items-end justify-between">
        <div>
          <p className="text-xs text-secondary-800">用户评分（演示）</p>
          <p className="mt-1 font-heading text-3xl font-bold text-primary-700">
            {rating.toFixed(1)}
          </p>
        </div>
        <div className="flex gap-0.5 text-accent-500">
          {[1, 2, 3, 4, 5].map((star) => (
            <i
              key={star}
              className={`${star <= fullStars ? "ri-star-fill" : "ri-star-line"} text-lg`}
            ></i>
          ))}
        </div>
      </div>
      <div className="mt-4 h-2 w-full overflow-hidden rounded-full bg-background-50">
        <div
          className="h-full rounded-full bg-accent-500"
          style={{ width: `${(rating / 10) * 100}%` }}
        ></div>
      </div>
      <p className="mt-3 flex items-center gap-1.5 text-[11px] leading-relaxed text-secondary-700">
        <i className="ri-information-line"></i>
        评分与评价均为虚构示例，不代表任何真实数据。
      </p>
    </div>
  );
}